import { Box, Link, Typography } from '@mui/material'
import React from 'react'
import { SectionTitle, ScrollFadeInSlideUp, ScrollReveal } from '../../../components'

const CareerBePart = () => {
  return (
    <Box
      sx={{
        paddingBottom:'3rem',
        background:'linear-gradient(to right, #A6A6A6, #fefefe)',
      }}
    >
      <ScrollFadeInSlideUp 
          sx={{
            paddingY:'2rem'
          }}
        direction='right'>
      <SectionTitle 
        firstTitleWord='Ready to join'
        secondTitleWord='Pangu Enterprises?'
        textStyle={{
          '@media screen and (max-width:762px)':{
            fontSize:'2rem'
          }
        }}
      />
      </ScrollFadeInSlideUp>
      <ScrollReveal threshold='0.5'>
        <Typography
          sx={{
            marginLeft:'5rem',
            fontFamily:'var(--text-font)',
            fontSize:'1.3rem',
            width:'70%',
            '@media screen and (max-width: 762px)':{
              fontSize:'1rem'
            }
          }}
        >
          We're looking for talented individuals to help us build excellence. Simply send your Resume, Supporting Documents, and a brief note about why you'd be a great fit to<span style={{fontWeight:'bold'}}> applications@pangu.ventures</span>.<br /> <br/>
          Our team will review your application and reach out if there's a match.
        </Typography>
      </ScrollReveal>
    </Box>
  )
}

export default CareerBePart